import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IProduct } from 'src/app/storage/interfaces/product.interface';
import { Mission } from 'src/app/storage/models/mission.model';
import { ProductMission } from 'src/app/storage/models/product-mission.model';
import { Product } from 'src/app/storage/models/product.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getProducts(showLoader = true): Promise<Product[] | null> {
    const translations = await this.translateService.get('PRODUCTS').toPromise();

    const response = await this.apiService.get(
      `${URL}products`,
      translations['LABEL'],
      { showLoader }
    );

    return response ?
          response.products.map((product: IProduct) => new Product(product)) :
          null;
  }

  async updateMissionProduct(mission: Mission, missionProduct: ProductMission): Promise<boolean> {
    const translations = await this.translateService.get('PRODUCTS').toPromise();

    const payload = { productmissionLoadedExpectedMassTotal: missionProduct.productmissionLoadedExpectedMassTotal };
    
    const response = await this.apiService.post(
      `${URL}products/product/${missionProduct.productName}/mission/${mission.missionId}`,
      payload,
      translations['LABEL'],
      { showLoader: true }
    );

    return response != null;
  }
}
